<template>
  <section>
    <ul class="list-unstyled ps-0 custom-links">
      <li v-for="n of nav" :key="n.root" class="mb-1">
        <button class="btn btn-toggle align-items-center rounded" :class="{ hidden: n.root.trim() === '' }"
          data-bs-toggle="collapse" :data-bs-target="`#${n.root}-collapse`" aria-expanded="true">
          {{ n.root }}
        </button>
        <div :id="`${n.root}-collapse`" class="collapse show">
          <ul class="navbar-nav btn-toggle-nav list-unstyled fw-normal pb-1 small custom-link">
            <li v-for="p of n.pages" :key="p.name" class="nav-item">
              <router-link exact :to="p.url" class="nav-link">
                <i :class="[{ hidden: p.icon.trim() === '' }, p.icon]"></i>
                <span>{{ p.name }}</span>
              </router-link>
            </li>
            <li class="nav-item d-block mt-5 d-none">
              <a id="logout" href="#" class="nav-link custom-submit" title="logout" @click="submitIssue"> Submit Issue
              </a>
            </li>
          </ul>
        </div>
      </li>
    </ul>
  </section>
</template>
<!-- eslint-disable no-undef -->
<script>
import { mapState, mapActions } from 'pinia'
import { authStore } from '@/stores/auth'
import { adasIqStore } from '@/stores/adasIq'
export default {
  name: 'NavLeft',
  data() {
    return {
      searchText: '',
      isCollapsed: false,
      nav: [
        {
          root: '',
          isActive: true,
          isHidden: false,
          pages: [{ url: '/', name: 'Home', icon: '', isHidden: false }]
        }
      ],
      navSupport: [],
      submitFormUrl: '',
      adasInspection: null,
    }
  },
  mounted() {
    this.initMenu()
    this.submitFormUrl = window.config ? window.config.submitFormUrl : ''
    this.checkAdasIq()
  },
  watch: {
    adasIqAllowed() {
      this.initMenu()
    }
  },
  computed: {
    ...mapState(authStore, ['profile']),
    ...mapState(adasIqStore, { adasIqAllowed: 'allowed' }),
    isSuperAdmin() {
      let _is = false
      if ([1].includes(this.profile.roles[0])) {
        _is = true
      }
      return _is
    },
    isAdmin() {
      let _is = false
      if ([2, 3, 4, 5, 7, 9, 11].includes(this.profile.roles[0])) {
        _is = true
      }
      return _is
    }
  },
  methods: {
    ...mapActions(authStore, ['clearToken']),
    ...mapActions(adasIqStore, { checkAdasIq: 'check' }),
    initMenu() {
      let _nav = []
      this.nav = [
        {
          root: '',
          isActive: true,
          isHidden: false,
          pages: [{ url: '/', name: 'Home', icon: '', isHidden: false }]
        }
      ]
      if (this.isAdmin || this.isSuperAdmin) {
        _nav = [
          {
            url: '/inspections',
            name: 'Repairs',
            icon: 'fa-solid fa-file-contract',
            isHidden: false
          }
        ]
      } else {
        _nav = [
          {
            url: '/inspections',
            name: 'Repairs',
            icon: 'fa-solid fa-file-contract',
            isHidden: false
          }
        ]
      }
      // #668: same VIN overview entry point as ADAS Map, for every role.
      _nav.push({
        url: '/overview',
        name: 'ADAS Systems Overview',
        icon: 'fa-solid fa-file-lines',
        isHidden: false
      })
      if (this.isSuperAdmin) {
        _nav.push({
          url: '/pricing-rules',
          name: 'Insurer Discount Rules',
          icon: 'fa-solid fa-percent',
          isHidden: false
        })
      }
      // #620: ADAS IQ, only for users ADAS IQ says may use it (the Launchpad access flag,
      // asked once per page load; see stores/adasIq.js).
      if (this.adasIqAllowed) {
        _nav.push({
          url: '/adas-iq',
          name: 'ADAS IQ',
          icon: 'fa-solid fa-comments',
          isHidden: false
        })
      }
      this.nav[0].pages = this.nav[0].pages.concat(_nav)
      this.navSupport = [
        // { name: 'Submit Issue', icon: '', action: 'about' },
        { name: 'Logout', icon: '', action: 'logout' }
      ]
      console.log('Nav Items', this.nav)
    },
    isActive() {
      return true
    },
    isVisible(pages) {
      return pages.some((p) => this.store.isAllowed(p.url))
    },
    search() {
      this.isCollapsed = false
      for (let n of this.nav) {
        n.isHidden = false
        let count = 0
        for (let p of n.pages) {
          p.isHidden = !p.name.toLowerCase().includes(this.searchText.toLowerCase())
          if (!p.isHidden) {
            count++
          }
        }
        n.isHidden = !count
      }
      this.$forceUpdate()
    },
    performAction(action) {
      if (action === 'about') {
        this.$router.push('/about')
      } else if (action === 'logout') {
        this.clearToken()
        window.location.assign('/')
      }
    },
    submitIssue() {
      let baseUrl = this.submitFormUrl
      let url = baseUrl
        .replace('[SHOPNAME]', userProfile.firmName)
        .replace('[FULLNAME]', `${userProfile.firstName} ${userProfile.lastName}`)
        .replace('[EMAIL]', userProfile.username)
      if (this.adasInspection) {
        url = url.replace('[INSPECTION_ID]', this.adasInspection.adasInspection)
        url = url.replace('[INSURANCE]', this.adasInspection.insuranceName)
        url = url.replace('[RONUMBER]', this.adasInspection.ronumber)
        url = url.replace('[OPTIN]', this.adasInspection.isOptIn ? (this.adasInspection.isOptIn === 1 ? 'true' : 'false') : 'false')
        if (this.adasInspection.vehicle) {
          url = url.replace('[VIN]', this.adasInspection.vehicle.vin)
          url = url.replace('[YEAR]', this.adasInspection.vehicle.year)
          url = url.replace('[MAKE]', this.adasInspection.vehicle.make)
          url = url.replace('[MODEL]', this.adasInspection.vehicle.model)
        } else {
          url = url.replace('[VIN]', '')
          url = url.replace('[YEAR]', '')
          url = url.replace('[MAKE]', '')
          url = url.replace('[MODEL]', '')
        }
        if (this.isProvider) {
          url = url.replace('[PROVIDERNAME]', this.adasInspection.providerName)
          url = url.replace('[INSURANCEPARTNER]', this.adasInspection.isOptIn === 1 ? this.adasInspection.insuranceName : '')
        }
      } else {
        url = url.replace('[INSPECTION_ID]', '')
        url = url.replace('[INSURANCE]', '')
        url = url.replace('[RONUMBER]', '')
        url = url.replace('[OPTIN]', '')
        url = url.replace('[VIN]', '')
        url = url.replace('[YEAR]', '')
        url = url.replace('[MAKE]', '')
        url = url.replace('[MODEL]', '')
      }
      window.open(url, '_blank')
    }
  }
}
</script>
<style lang="scss" scoped>
.hidden {
  display: none;
}

.custom-active {
  font-weight: 500;
  color: #007bff;
}

.custom-links {
  padding-top: 1rem;
  padding-bottom: 1rem;
  margin-left: -15px;
  margin-right: -15px;
}

.custom-link {
  font-size: 1rem;
  line-height: 1.5;
  font-weight: 400;

  svg {
    width: 36px;
  }

  a {
    display: block;
    padding: 0.25rem 1.5rem;
    margin-top: 5px;
    margin-bottom: 5px;
    color: #fff;
  }
}

.badge-incoming {
  position: relative;
  top: -5px;
  display: inline-flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  color: white;
  background: darkgreen;
  position: relative;
  box-sizing: border-box;
  text-align: center;
  vertical-align: middle;
  font-weight: normal;
  font-size: 12px;
  border-radius: 18px;
  padding: 0 4px;
  height: 18px;
  min-width: 18px;
}

.custom-submit {
  position: relative;
  font-size: 0.8rem;
}
</style>
